import { apiGet, apiPost } from './utils';
import type {
  UserSettings, UserProfile, EmailPreferences, AdminUserSettings, BillingInfo, EmailAddressList, AccountSummary,
} from '../types';

export const settingsApi = {
  async getSettings(): Promise<UserSettings> {
    return apiGet<UserSettings>('/users/settings');
  },

  async updateSettings(data: Partial<UserProfile & EmailPreferences>): Promise<UserSettings> {
    return apiPost<UserSettings>('/users/settings', data as Record<string, unknown>);
  },

  async getAdminSettings(userUuid: string): Promise<AdminUserSettings> {
    return apiGet<AdminUserSettings>(`/users/support/settings/${userUuid}`);
  },

  async updateAdminSettings(
    userUuid: string,
    data: Partial<UserProfile & EmailPreferences>
  ): Promise<AdminUserSettings> {
    return apiPost<AdminUserSettings>(`/users/manager/settings/${userUuid}`, data as Record<string, unknown>);
  },

  async listEmails(): Promise<EmailAddressList> {
    return apiGet<EmailAddressList>('/users/email/list');
  },

  // Emails a verification link to the address; it's pending until clicked.
  async addEmail(email: string): Promise<EmailAddressList> {
    return apiPost<EmailAddressList>('/users/email/add', { email });
  },

  async removeEmail(email: string): Promise<EmailAddressList> {
    return apiPost<EmailAddressList>('/users/email/remove', { email });
  },

  async setPrimaryEmail(email: string): Promise<EmailAddressList> {
    return apiPost<EmailAddressList>('/users/email/set-primary', { email });
  },

  async verifyEmail(token: string): Promise<{ email: string }> {
    return apiPost<{ email: string }>('/users/email/verify', { token });
  },

  async getBillingInfo(): Promise<BillingInfo> {
    return apiGet<BillingInfo>('/users/billing-info');
  },

  async getAccountSummary(): Promise<AccountSummary> {
    return apiGet<AccountSummary>('/users/account-summary');
  },
};
